import { render, staticRenderFns } from "./EditarUnidade.vue?vue&type=template&id=a9698606&scoped=true"
import script from "./EditarUnidade.vue?vue&type=script&lang=js"
export * from "./EditarUnidade.vue?vue&type=script&lang=js"
import style0 from "./EditarUnidade.vue?vue&type=style&index=0&id=a9698606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9698606",
  null
  
)

export default component.exports